module.exports = __webpack_public_path__ + "img/caret-left-square.b944aae5.svg";